import apiClient from "../apiClient";

const resource = "employeeHealth";

export default {
    getAll: params => apiClient.get(`${resource}?${params}`),
    add: payload => apiClient.post(`${resource}`, payload),
    getDetails: id => apiClient.get(`${resource}/${id}/details`),
    getForEdit: id => apiClient.get(`${resource}/${id}`),
    edit: (id, payload) => apiClient.put(`${resource}/${id}`, payload,{ 'Content-Type': 'multipart/form-data' }),
    delete: id => apiClient.delete(`${resource}/${id}`),
};